import React from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { BasketSummaryDetailsAC } from './AC/BasketSummaryDetails.AC';
import { BasketSummaryDetailsOV } from './OV/BasketSummaryDetails.OV';
import { BasketSummaryDetailsAP } from './AP/BasketSummaryDetails.AP';
import { BasketSummaryDetailsDS } from './DS/BasketSummaryDetails.DS';
import { BasketSummaryDetailsOV as BasketSummaryDetailsOV_GB } from './OV/GB/BasketSummaryDetails.OV';
import { BasketSummaryDetailsStyled } from './BasketSummaryDetailsStyled';
import { SC } from 'src/styles/theme';
import { Pages } from 'src/types/pages';

export type BasketSummaryDetailsProps = SC & {
    closePriceSummary?: () => void;
    setIsOpenPriceDetails?: (open: boolean) => void;
    isTopMargin?: boolean;
    page?: Pages;
};

const BasketSummaryDetails = (props: BasketSummaryDetailsProps) => {
    if (BRAND === 'AC') return <BasketSummaryDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <BasketSummaryDetailsOV_GB {...props} /> : <BasketSummaryDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketSummaryDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketSummaryDetailsDS {...props} />;
    return <BasketSummaryDetailsStyled {...props} />;
};

export default BasketSummaryDetails;
